export default "__VITE_ASSET__Dt382T$B__"